import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../component/Header'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import OtherService from '../services/Other'
import Loader from '../component/Loader'
import PrimaryGradientButton from '../component/PrimaryGradientButton'

const GalleryImage = () => {
  const { contentId } = useParams()
  //All States
  const [isGalleryImage, setIsGalleryImage] = useState([])
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(true);
  //All useEffect//
  useEffect(() => {
    const galleryImageResponse = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const galleryImageResponse = await OtherService.gallery(token, contentId);
        if(galleryImageResponse.error == false)
        {
          if(galleryImageResponse.data.imageDetails.length > 0){
            // The API always returns every photo in the gallery
            // spot, so pick the one matching the current contentId
            // instead of always taking the first one.
            const matchedImage =
              galleryImageResponse.data.imageDetails.find(
                (image) =>
                  String(image.contentDetails?.id) ===
                  String(contentId)
              ) || galleryImageResponse.data.imageDetails[0]

            setIsGalleryImage(matchedImage.files)
            setLoading(false)
          }
          else{
            setLoading(false)
            setNoData(true)
          }
        }
        else{
          setLoading(false)
          setNoData(true)
        }
      }
      catch (error) {
        console.error('Error:');
      }
    }
    galleryImageResponse()
  }, [])
  const navigate = useNavigate()
  const handleBack = () =>{
    navigate(`/gallery`);
  }
  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion
        pageTitle="Photo"
        currentPageName="Photo" />
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
              <div className='buttonWrap my-4'>
                <PrimaryGradientButton buttonText="Back" onClick={handleBack} />
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className='userInfoBox'>
          {noData && 
                    <Row>
                      <Col><div className="noDataMsg">No data found!</div></Col>
                    </Row>
                     }
            <Row>
              {isGalleryImage?.map((item) => {
                const { id, title, file_path } = item
                return (
                  <Col xs={12} lg={3} key={id} className='galleryImgBox'>
                    <div className='itemWrap'>
                      <div className='itemWrapImage'>
                        <img src={file_path} className='img-fluid' alt='imageName' />
                      </div>
                      <div className="itemWrapImageTxt"><p>{title}</p></div>
                    </div>

                  </Col>
                )
              })}

            </Row>
          </div>

        </Container>
      </section>
    </>
  )
}

export default GalleryImage